// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__d0mz1","box":"WorkspacesBox_box__3391r","node":"WorkspacesBox_node__1LdQT"};